import React from 'react'
import { DateTime } from 'luxon'

import { LineChart } from 'react-chartkick'
import 'chart.js'

const TagMeasurements = ({ data, tag }) => {
    const formatDate = date => {
        return DateTime.fromISO(date).setLocale("fi").toFormat("EEE dd.MM.yyyy")
    }

    let plotData = {}

    data.forEach(entry => {
        if (entry.tags[0].value) {
            plotData[DateTime.fromISO(entry.date).toFormat("yyyy-MM-dd")] = Number(entry.tags[0].value)
        }
    })

    return (
        <div>
            <h1>#{tag}</h1>
            <LineChart
                data={plotData}
                min={null}
                label={tag}
                library={{ 
                    scales: {
                        xAxes: [{
                            time: {
                                tooltipFormat: 'ddd DD.MM.YYYY'
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                display: false
                            }
                        }]
                    }
                }}
            />
            <table>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                {data.map((entry, i) => {
                    return <tr key={i}>
                        <td>{formatDate(entry.date)}</td>
                        <td>{entry.tags[0].value}</td>
                    </tr>
                })}
                </tbody>
            </table>
        </div>
    )
}

export default TagMeasurements